// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__34vcZ","name":"ConsentHeader_name__2df88","birthday":"ConsentHeader_birthday__9WPxA","skeleton":"ConsentHeader_skeleton__1rFw6"};